// This function allow to reference all chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 137 ? "tinper-next" : chunkId) + ".min.js";
};